// extracted by mini-css-extract-plugin
export default {"root":"Workshop_root__GpjFd"};